export * from "./header/header.component";
export * from "./search-list/search-list.component";
export * from "./patient-billing-modal/patient-billing-new-modal.component";
export * from "./patient-details-modal/patient-details-new-modal.component";
export * from "./login/admin-portal-login.component";
export * from "./login/physician-portal-login.component";
export * from "./login/patient-portal-register.component";
export * from "./patient-billing-modal/patient-billing-edit-modal.component";
export * from "./patient-details-modal/patient-details-edit-modal.component";
export * from "./custom-accordion/custom-accordion.component";
export * from "./not-found/not-found.component";
export * from "./no-access/no-access.component";
export * from "./custom-dropdown/custom-dropdown.component";
export * from "./info-modal/info-modal.component";
export * from "./patient-additional-details-modal/patient-additional-details-new-modal.component";
export * from "./patient-additional-details-modal/patient-additional-details-edit-modal.component";
export * from "./location-user-assignment-modal/location-user-assignment-modal.component";
export * from "./shared-components.module";
export * from "./session-timeout-modal/session-timeout-modal.component";
export * from "./spinner/spinner.component";



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/index.ts